var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconGame(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 22,
    viewBox: "0 0 28 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "game_unactive",
    "data-name": "game unactive",
    transform: "translate(-2 -6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_948_",
    d: "M29,14.481C28.3,9.635,24.5,6,20.1,6H12C7.5,6,3.7,9.635,3,14.481c-.7,5.177-1,7.49-1,8.371,0,5.4,6.7,7.16,8.9,2.313l1.7-3.745h6.8l1.7,3.745c2.2,4.847,8.9,3.084,8.9-2.313,0-.771,0,.22-1-8.371Zm-1,8.371c0,3.084-3.9,4.186-5.1,1.322l-2-4.406a1.033,1.033,0,0,0-.9-.551H12a.963.963,0,0,0-.9.661l-2,4.406C7.9,27.038,4,25.937,4,22.853l1-8.041C5.5,11.067,8.5,8.2,11.9,8.2H20c3.5,0,6.4,2.864,6.9,6.609.1.11,1.2,8.592,1.1,8.041Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_82_",
    d: "M14,13a.945.945,0,0,1-1,1H12v1a.945.945,0,0,1-1,1,.945.945,0,0,1-1-1V14H9a1,1,0,0,1,0-2h1V11a.945.945,0,0,1,1-1,.945.945,0,0,1,1,1v1h1A.945.945,0,0,1,14,13Z",
    transform: "translate(0 1)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_84_",
    d: "M20,13a1,1,0,1,1-1-1A.945.945,0,0,1,20,13Z",
    transform: "translate(0 1)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_85_",
    d: "M22,15a1,1,0,1,1-1-1A.945.945,0,0,1,22,15Z",
    transform: "translate(0 1)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_86_",
    d: "M24,13a1,1,0,1,1-1-1A.945.945,0,0,1,24,13Z",
    transform: "translate(0 1)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_87_",
    d: "M20,11a1,1,0,0,1,2,0,1,1,0,0,1-2,0Z",
    transform: "translate(0 1)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGame);
export default __webpack_public_path__ + "static/media/icon_game.b7449914b7ab19c02dcc58f4531be02a.svg";
export { ForwardRef as ReactComponent };